import { Flex, Stack, Text } from '@chakra-ui/react';
import type { DashboardTodoSourceKey } from '@fluenceur/types';
import { NavArrowRight } from 'iconoir-react';
import { Link as RouterLink } from 'react-router-dom';
import { TodoLineIcon } from './TodoLineIcon';

interface TodoRowProps {
  lineKey: DashboardTodoSourceKey;
  href: string;
  label: string;
  subtitle: string;
  count: number;
}

/** One subject waiting on the brand: a link to the page it is handled on. */
export const TodoRow = ({ lineKey, href, label, subtitle, count }: TodoRowProps) => (
  <Flex
    asChild
    align="center"
    gap="12px"
    px="12px"
    py="11px"
    borderRadius="10px"
    borderTopWidth="1px"
    borderTopColor="border.subtle"
    color="ink"
    textDecoration="none"
    _hover={{ bg: 'softCream/60' }}
    _focusVisible={{ outline: '2px solid', outlineColor: 'primary.focusRing' }}
  >
    <RouterLink to={href}>
      <TodoLineIcon lineKey={lineKey} />
      <Stack gap="2px" flex="1" minW="0">
        <Text fontSize="14px" fontWeight="500" lineClamp={1}>
          {label}
        </Text>
        {subtitle && (
          <Text fontSize="12.5px" color="inkMuted" lineClamp={2}>
            {subtitle}
          </Text>
        )}
      </Stack>
      <Text fontFamily="heading" fontSize="18px" fontWeight="600" fontVariantNumeric="tabular-nums">
        {count}
      </Text>
      <Flex color="inkSubtle" aria-hidden="true">
        <NavArrowRight width={16} height={16} />
      </Flex>
    </RouterLink>
  </Flex>
);
